// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import Auth from './store/auth';

Vue.use(LoadScript);

/**
 * Firebase  설정
 */
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyC31PWyIQctMUltFiUEk3tHYnKvtO4JteY",
  authDomain: "uko-projects.firebaseapp.com",
  databaseURL: "https://uko-projects.firebaseio.com",
  projectId: "uko-projects",
  storageBucket: "uko-projects.appspot.com",
  messagingSenderId: "81206162832",
  appId: "1:81206162832:web:926b9745a50d1466f86f15",
  measurementId: "G-XK8VTY9ZQE"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


Vue.config.productionTip = false
const EventBus = new Vue();
window.auth = new Auth();
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data:{
    authorised: false,
  },
  created() {
    const _self = this;
    this.$on("onLogonSuccss", function(auth){
      _self.authorised = auth;
    })
  }
})
window.app = vm



// WEBPACK FOOTER //
// ./src/main.js